export default "__VITE_ASSET__3dZiqrpO__"